<template>
  <div>
    <input type="tel" name="order-number" class="order-number-input" v-model="order_number" placeholder="デザインNo.">
    <vk-button v-if="order_number" @click="previewLoadCart" class="order-trigger">
      デザイン呼出
    </vk-button>
    <vk-button v-else-if="check_able_order" @click="saveCart" class="order-trigger">
      一時保存
    </vk-button>
    <vk-button v-else disabled class="order-trigger" style="line-height: 15px;">
      一時保存
    </vk-button>
    <div :show.sync="modalOrderSaveShow"
         :class="{'uk-modal':true,'uk-open':modalOrderSaveShow}"
         @clickOut="modalOrderSaveShow = false"
         @inactive="modalOrderSaveShow = false"
         @keyEsc="modalOrderSaveShow = false">
      <div class="uk-modal-dialog">
        <div class="uk-modal-body">
          <div class="uk-modal-header">
            <h2>一時保存</h2>
          </div>
          <div class="uk-modal-body" style="color:black;">

            <p>デザインを一時保存しました。</p>

            <p>デザインＮｏは
              <span class="cart_number">{{cart_number}}</span>
              です。
            </p>
            <p>次回、上記の番号を入力して「デザイン呼出」を選択すれば現在のデザインを呼び出すことができます。</p>
            <p>※まだ注文は完了おりません。</p>
            <vk-button v-if="check_able_order" class="button-order uk-width-1-1" @click="clickButtonOrder">
              このデザインで注文
            </vk-button>
          </div>

          <div class="uk-modal-footer">
            <vk-button @click="modalOrderSaveShow = false">閉じる</vk-button>
          </div>
        </div>
      </div>
    </div>
    <div id="modal-order-preview" :show.sync="modalOrderLoadShow"
         :class="{'uk-modal':true,'uk-open':modalOrderLoadShow}"
         @clickOut="modalOrderLoadShow = false"
         @inactive="modalOrderLoadShow = false"
         @keyEsc="modalOrderLoadShow = false">
      <div class="uk-modal-dialog">
        <div class="uk-modal-body">
          <div class="uk-modal-header">
            <h2>呼出</h2>
          </div>
          <div class="uk-modal-body" style="color:black;" v-if="!preview_error">
            <p>以下のデータを呼び出しますか？</p>

            <div id="preview_front" style="position:relative; height: 90px; float:left;">
              <part v-for="part in preview_cart.parts" :key="'fp_'+part.id" :part="part" :reverse="reverse=0"></part>
              <letter v-for="letter in preview_cart.letters" :key="'fl_'+letter.id" :letter="letter" :reverse="reverse"></letter>
            </div>
            <div id="preview_back" style="position:relative;  height: 90px; float:left;">
              <part v-for="part in preview_cart.parts" :key="'bp_'+part.id" :part="part" :reverse="reverse=1"></part>
              <letter v-for="letter in preview_cart.letters" :key="'bl'+letter.id" :letter="letter" :reverse="reverse"></letter>
            </div>
            <p style="clear:both;">No.{{order_number}}</p>
            <p>※現在のデータはクリアされます。</p>
          </div>
          <div class="uk-modal-body" style="color:black; " v-else>
            入力したオーダーＮｏは存在しません。再度確認頂き入力してください。
            <p class="cart_number">No.{{order_number}}</p>
          </div>

          <div class="uk-modal-footer">
            <div class="buttons">
              <vk-button @click="modalOrderLoadShow = false">キャンセル</vk-button>
              <vk-button @click="loadCart">決定</vk-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import Part from '../preview/Part.vue'
  import Letter from '../preview/Letter.vue'

  import axios from 'axios/dist/axios.min'
  import { mapGetters } from 'vuex'

  export default {
    name: 'order-loader',
    components: {Part, Letter},
    data () {
      return {
        show: false,
        order_number: '',
        modalOrderSaveShow: false,
        modalOrderLoadShow: false,
        preview_cart: {
          category: null,
          design: null,
          figure: null,
          number: null,
          parts: [],
          letters: [],
          packs: [],
          order: {
            comment:null,
            email:null,
            name:null,
            team:null,
          },
        },
        preview_error: false,
      }
    },
    computed: {
      ...mapGetters([
        'check_able_order'
      ]),
      cart_number(){
        return this.$store.state.cart.number;
      }
    },
    methods: {
//      ...mapMutations(['changeActiveTab']),
      saveCart(){
        axios.post('/carts/add.json',
          {json: this.$store.state.cart}
        ).then(response => {
          this.modalOrderSaveShow = true;
          this.$store.commit('setCartNumber', response.data.cart.code);
          this.order_number = response.data.id;
        });
      },
      previewLoadCart(){
        this.modalOrderLoadShow = true;
        if (this.order_number.length === 8) {
          axios.get('/carts/' + this.order_number + '.json',
            {json: this.$store.state.cart}
          ).then(response => {
            this.preview_error = false;
            let json = JSON.parse(response.data.cart.json);
            this.preview_cart = {
              category: json.json.category,
              design: json.json.design,
              figure: json.json.figure,
              number: json.json.number,
              parts: json.json.parts,
              letters: json.json.letters,
              packs: json.json.packs,
              order: json.json.order,
            };
          }).catch(() => {
            this.preview_error = true;
          });
        } else if (this.order_number.length === 9) {
          axios.get('/stock_designs/' + this.order_number + '.json',
            {json: this.$store.state.cart}
          ).then(response => {
            this.preview_error = false;
            let json = JSON.parse(response.data.stock_design.json);
            this.preview_cart = {
              category: json.category,
              design: json.design,
              figure: json.figure,
              number: json.number,
              parts: json.parts,
              letters: json.letters,
              packs: json.packs,
              order: json.order,
            };
          }).catch(() => {
            this.preview_error = true;
          });
        }
      },
      loadCart(){
        this.modalOrderLoadShow = false;
        if (this.order_number.length === 8) {
          axios.get('/carts/' + this.order_number + '.json',
            {json: this.$store.state.cart}
          ).then(response => {
            let json = JSON.parse(response.data.cart.json);
            // サイズ・個数の初期化
            json.json.packs = [
              {
                size_name: null,
                size_id: "",
                value: null,
                number: "",
                name: null,
                pack_price: null,
              }
            ];
            // お客様情報の初期化
            json.json.order = {
              email: null,
              name: null,
              team: null,
              comment: null,
            };
            this.$store.commit('setCartJson', {
              // number: response.data.cart.code,
              // json: json
              category: json.json.category,
              figure: json.json.figure,
              design: json.json.design,
              parts: json.json.parts,
              letters: json.json.letters,
              packs: json.json.packs,
              number: response.data.cart.code,
              order: json.json.order,
            });
            this.$store.commit('clearActiveTab');
            this.$router.push({name: 'color'});
          });
        } else if (this.order_number.length === 9) {
          axios.get('/stock_designs/' + this.order_number + '.json',
            {json: this.$store.state.cart}
          ).then(response => {
            this.preview_error = false;
            let json = JSON.parse(response.data.stock_design.json);
            // サイズ・個数の初期化
            json.packs = [
              {
                size_name: null,
                size_id: "",
                value: null,
                number: "",
                name: null,
                pack_price: null,
              }
            ];
            this.$store.commit('setCartJson', {
              // number: response.data.cart.code,
              // json: json
              category: json.category,
              figure: json.figure,
              design: json.design,
              parts: json.parts,
              letters: json.letters,
              packs: json.packs,
            });
            this.$store.commit('disableAfterActiveTab', 3);
            this.$router.push({name: 'color'});
          });
        }
      },
      clickButtonOrder(){
        this.modalOrderSaveShow = false;
        // this.$store.commit('changeActiveTab', 5);
        this.$router.push({name: 'estimate'});
      }
    }
  }
</script>

<style lang="scss" scoped>
  #modal-order-preview /deep/ .picture {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    width: 100px;
    height: 80px;
  }

  input {
    padding: 8px 2px;
    text-align: center;
  }

  .cart_number {
    display: block;
    margin: 12px 4px;
    text-align: center;
    padding:0;
  }

  .order-number-input{
    height: 34px;
    width: 110px;
    line-height: 16px;
    font-size: 16px;
    padding: 0;
    border-radius: 3px;
  }
  @media (min-width: 800px) {
    .order-number-input{
      width: 320px;
    }
  }
  .button-order{
    background-color:#151d66;
    margin: 0 auto;
  }
  .order-trigger{
    border-radius: 3px;
    line-height: 25px;
    margin-left: 4px;
    font-size: 12px;
    padding: 0 8px;
  }
  #preview_front {
    width: 100px;
  }

  #preview_back {
    width: 100px;
  }

  #modal-order-preview>.uk-modal-dialog{
    z-index:1000;
  }

  .uk-modal-footer{
    text-align:center;
  }
  .uk-modal-footer .uk-button{
    background-color:#151d66;
    border:0;
  }
  .uk-modal-footer .uk-button:hover{
    color:white;
  }
  /* アニメーション後に自動でuk-openがついてくれなくなったので仕方なくvk-modalを自分で実装 */
  .uk-modal.uk-open{
    display:block;
  }
  .uk-button:disabled {
    background-color: rgb(54,62,110);
    color: rgb(72,92,146);
    border: 0;
  }
  .buttons {
    .uk-button {
      margin: 0 4px;
    }
  }
</style>
